<template>
  <el-popover placement="bottom"
              :width="calWidth"
              trigger="click">
    <!--重置-->
    <el-button @click="resetChecked"
               type="text"
               size="mini">{{ $t('reset') }}</el-button>
    <el-tree ref="classTrees"
             class="catalog-tree-contain"
             :data="treeData"
             show-checkbox
             @check-change="handleCheckChange"
             node-key="catalogId"
             :props="defaultProps"
             :default-checked-keys="showArray"
             default-expand-all>
      <div class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
      </div>
    </el-tree>
    <el-input slot="reference"
              :placeholder="$t('user.select')"
              clearable
              readonly
              v-model.trim="className"></el-input>
  </el-popover>
</template>
<script>
import { treeDataTranslate } from '@/utils';
export default {
  name: 'courseTaskCatalogTree',
  props: {
    calWidth: {
      type: Number,
      default: 240
    },
    targetCourseCatlog: {
      type: Boolean,
      default: false
    },
    // 默认是单选
    isSelect: {
      type: Boolean,
      default: true
    },
    defaultProps: {
      type: Object,
      default: null,
      required: true
    },
    url: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      treeData: [],
      dataListLoading: false,
      className: '',
      showArray:[]
    };
  },
  methods: {
    // 分类树
    queryClass () {
      this.dataListLoading = true;
      this.$request.get(this.url, { 'disable': this.isSelect ,'type': 10})
      .then((res) => {
        this.dataListLoading = false;
        this.treeData = treeDataTranslate(res, 'catalogId', 'parentCatalogId');
        if (this.targetCourseCatlog) {
          this.treeData = this.treeData.concat([{
            catalogId: 'courseCombine',
            catalogNameCn: this.$t('courseSchedule.courseCombine')
          }, { 
            catalogId: 'courseSplit',
            catalogNameCn: this.$t('courseSchedule.courseSplit')
          }]);
        }
      }).catch(() => {
        this.dataListLoading = false;
      });
    },
    // 重置车型分类树
    resetChecked() {
      this.$refs.classTrees.setCheckedKeys([]);
    },
    // 勾选分类树 树时调用
    handleCheckChange (data, checked) {
      const choseData = this.$refs.classTrees.getCheckedNodes();
      const cnName = this.defaultProps.label;
      let checkedShowValTem = [];
      if (choseData.length === 0) {
        if (this.isSelect && checked === true) {
          this.$refs.classTrees.setCheckedNodes([data]);
        }
        this.$refs.classTrees.getCheckedNodes(true, false).forEach((item) => {
          checkedShowValTem.push(item[cnName]);
        });
      } else {
        checkedShowValTem = choseData.map((item) => {
          return item[cnName];
        });
      }
      this.className = checkedShowValTem.join(',');
      const cData = choseData.map((item) => {
        return { catalogId: item.catalogId, catalogNameCn: item.catalogNameCn };
      });
      this.$emit('cateloglist', [{ data: cData }]);
    }
  },
  mounted () {
    this.queryClass();
  }
};
</script>
<style lang="scss" scoped>
.catalog-tree-contain {
  max-height:400px;
  overflow-y: auto;
}
</style>